import { render, staticRenderFns } from "./PropertyAssets.vue?vue&type=template&id=7bbd4b3e&scoped=true&"
import script from "./PropertyAssets.vue?vue&type=script&lang=js&"
export * from "./PropertyAssets.vue?vue&type=script&lang=js&"
import style0 from "./PropertyAssets.vue?vue&type=style&index=0&id=7bbd4b3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbd4b3e",
  null
  
)

export default component.exports